import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css'],
  providers: [HelperService] 
})

export class SubscriptionComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
  @ViewChild(DataTableDirective)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  view=false;
  icon=this.helper.add_icon;
  icon_action='addClick';

  chapter_name='';
  all:any=[];
  selected:any=[];
  subject_id=0;
  subscription_id=0;
  syllabus_list:any=[];
  grade_list:any=[];
  subject_list:any=[];
  selected_grade_id:any=[];
  selected_syllabus_id:any=[];
  selected_subject_id:any=[];
  selected_syllabus_grade_id:any=[];
  selected_price='';
  red='';
  todayDate:Date = new Date();
  user=this.cookie.get('user_id');
  expiry_date;
  editexpiry_date;
  enddate;
  mode;
  description;
  validity;
  status;
  editenddate;
  selectedOption=[];
  syllabusname;
  gradename;
  packagename;
  price;
  createdBy;
  createdOn;
  selectedSubjects = [];
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
    activatedRouter.queryParams.subscribe(params => {
      if(params['id'])
      {
        let id = params['id'];

        this.http.get(this.helper.base_url+'http/get/subscriptionDetail/'+id,{ headers: this.headers })
          .map(this.extractData)
          .subscribe(data => {
          
            this.viewClick(data[0].syllabusname,data[0].gradename,data[0].name,data[0].price,data[0].mode,data[0].description,data[0].validity,data[0].expiry_date,data[0].status,data[0].createdUSer,data[0].currentdate,data[0].syllabus_id,data[0].syllabus_grade_id,data[0].subject_id);
            
           
          });
      }
    });
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/mainsubscription',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.datas = data;
        
          this.dtTrigger.next();
        
       
      });
      this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(syllabuses => {
        //console.log(syllabuses);
        this.syllabus_list = syllabuses;
        
      });

      let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     console.log(this.user_permissions);
        
     
    });

     
  }
  
  editClick(id,name,grade_id,syllabus_id,subject_id,price,syllabus_grade_id,mode,description,validity,expiry_date,status){
    
     this.selected_grade_id=grade_id;
     this.selected_syllabus_grade_id=syllabus_grade_id;;
     this.selected_syllabus_id=syllabus_id;
     this.selected_subject_id=subject_id;
    //  for(var i=0;i<this.selected_subject_id.length;i++)
    // {
    //   this.selected_subject_id.push(this.selected_subject_id[i]);
    // } 
  //this.selected_subject_id.setValue(this.selected_subject_id);
    //alert(this.selected_subject_id);
    this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
    .map(this.extractData)
    .subscribe(syllabuses => {
       
      this.syllabus_list = syllabuses;
      this.http.get(this.helper.base_url+'http/get/grade/'+syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.grade_list = data;
        this.http.get(this.helper.base_url+'http/get/subjects/'+syllabus_grade_id,{ headers: this.headers })
        .map(this.extractData)
        .subscribe(data => {
          this.subject_list = data['subject'];  
          //console.log(this.subject_list);   
        });
      });
     
    });

    

    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.chapter_name=name;
    this.selected_price=price;
    this.mode=mode;
    this.description=description;
    this.validity=validity;
    this.editexpiry_date=expiry_date;
    this.status=status;
    this.subscription_id=id;
    this.selectedOption = ['1','2'];
    this.editenddate = expiry_date;
    //this.selected_subject_id = ['48']
  }
  syllabusChange(event:any){
    let syllabus_id=event.target.value;
    this.subject_list=[];
   
    this.grade_list=[];

     this.selected_grade_id='';
     this.selected_syllabus_grade_id='';
   //  this.selected_syllabus_id='';
     this.selected_subject_id='';
    
    this.http.get(this.helper.base_url+'http/get/grade/'+syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.grade_list = data;
         
       
      });

  }
  gradeChange(event:any){

    let sgid=event.target[event.target.selectedIndex].dataset.sgid;
    
    this.subject_list=[];
   
    
    
     this.selected_subject_id='';
   
    this.http.get(this.helper.base_url+'http/get/subjects/'+sgid,{ headers: this.headers })
    .map(this.extractData)
    .subscribe(data => {
      this.subject_list = data['subject'];
       //console.log(this.subject_list);
    });

  }
  addClick(e){
   this.selected_syllabus_id='';
    this.grade_list = [];
    this.subject_list = [];

    this.list=false;
    this.edit=false;
    this.add=true;
    this.view=false;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.view=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  deleteClick(id){
   
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
        duration: 3000,
        extraClasses:  ['warning-snackbar'],
      });
      snackBarRef.onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/subscription/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) =>{
            let body = JSON.parse(data['_body']);
            //console.log(body)
            if(body.success == 1)
            {
              this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
          }, 
          //this.refresh(false,'Subscription deleted successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      );   
      });
  }
  viewClick(syllabusname,gradename,packagename,price,mode,description,validity,expiry_date,status,createdBy,createdOn,syllabus_id,syllabus_grade_id,selectedsubject_id)
  {
    //console.log(selectedsubject_id);
    let body = new FormData();
    //this.subject_list = []; 
    if(selectedsubject_id !=0)
    {
      body.append('subjectIds', selectedsubject_id);
      this.http.post(this.helper.base_url+'http/get/selectedsubjects', body,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(subjects => {
         //console.log(subjects);
        this.selectedSubjects = subjects;
       
      });
    }
    //this.selectedSubjects = [{"name":"Saab"},{"name": "Volvo"}, {"name":"BMW"}];
    //console.log(this.subject_list);
    this.list=false;
    this.edit=false;
    this.add=false;
    this.view=true;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.syllabusname = syllabusname;
    this.gradename = gradename;
    this.packagename = packagename;
    this.price = price;
    this.mode = mode;
    this.description = description;
    this.validity = validity;
    this.expiry_date = expiry_date;
    this.status = status;
    this.createdBy = createdBy;
    this.createdOn = createdOn;
  }

 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["subscription/"]));
      
 }
 add_form(addForm: NgForm){
  let body = new FormData();
  // alert(this.enddate);
  // return;
  //user=this.cookie.get('user_id');
  // console.log(addForm.value);
  // console.log(this.editenddate);
  // console.log(this.user);
  body.append('name', addForm.value.name);
  body.append('grade_id', addForm.value.grade);
  body.append('syllabus_id', addForm.value.syllabus);
  body.append('subjects', addForm.value.subjects);
  body.append('price', addForm.value.price);
  body.append('mode', addForm.value.mode);
  body.append('description', addForm.value.description);
  body.append('validity', addForm.value.validity);
  body.append('expiry_date', this.enddate);
  body.append('status', addForm.value.status);
  //body.append('userid', this.user);
   if(addForm.value.subjects!='' || addForm.value.subjects.length!=0){
this.http.post(this.helper.base_url+'http/add/subscription', body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let body = JSON.parse(res['_body']);
      //console.log(body)
      if(body.success == 1)
      {
        this.listClick(null) ;
        this.refresh(false,body.message) ;
      }
      else
      {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
      }
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
  }else{
      this.red='red';
  }
   
 }
 update_form(updateForm: NgForm){
  let id =this.subscription_id;
 let body = new FormData();
  //alert(this.editenddate);
 body.append('name', updateForm.value.name);
 //body.append('grade_id', updateForm.value.grade);
 //body.append('subjects', updateForm.value.subjects);
 body.append('syllabus_id', updateForm.value.syllabus);
 body.append('price', updateForm.value.price);
 //body.append('mode', updateForm.value.mode);
  body.append('description', updateForm.value.description);
  body.append('validity', updateForm.value.validity);
  body.append('expiry_date', this.editenddate);
  body.append('status', updateForm.value.status);


  this.http.post(this.helper.base_url+'http/update/subscription/'+id, body,{ headers: this.headers })
  .subscribe(
    (res) => {
      let body = JSON.parse(res['_body']);
      //console.log(body)
      if(body.success == 1)
      {
        this.listClick(null) ;
        this.refresh(false,body.message) ;
      }
      else
      {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
      }
    //  this.listClick(null) ;
    // this.refresh(false,'Subscription Updated Successfully') ;
    }, //For Success Response
     err => {console.error(err)} //For Error Response);
  );
}
startEvent(type: string, event: MatDatepickerInputEvent<Date>) {
  //alert("start");
 this.enddate = event.value;
 this.expiry_date= event.value;
  ////console.log(this.enddate);
  let d1 = new Date(Date.parse(this.enddate));
  this.enddate = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();
  //console.log(this.enddate);
  }
  editstartEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    //alert("end");
    this.editenddate = event.value;
    this.editexpiry_date= event.value;
     //console.log(this.editenddate);
     let d1 = new Date(Date.parse(this.editenddate));
     this.editenddate = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();
     //console.log(this.editenddate);
     }
  onStatusChange(value,id)
  {
    // alert(value);
    // alert(id);
    let body = new FormData();

    body.append('id', id);
    body.append('status', value);
    this.http.post(this.helper.base_url+'http/update/statussubscription', body,{ headers: this.headers })
    .subscribe(
      (res) => {
       this.listClick(null) ;
      this.refresh(false,'Subscription updated successfully') ;
      }, //For Success Response
       err => {console.error(err)} //For Error Response);
    );
  }
  
 


  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

}



// WEBPACK FOOTER //
// ./src/app/subscription/subscription.component.ts